// Module
var code = "<bringoz-button class=\"show-button\" bringoz-id-generator=\"showFieldsBtn\" type=\"tertiary\" (on-click)=\"$ctrl.onShowPanel($event)\"> <bringoz-icon icon-name=\"settings\" [fill]=\"'#757575'\"></bringoz-icon> </bringoz-button> ";
// Exports
export default code;